export default __webpack_public_path__ + "static/media/comptabilite.66bd6037.png";